import { render, staticRenderFns } from "./productManage.vue?vue&type=template&id=7f4b8698&scoped=true"
import script from "./productManage.vue?vue&type=script&lang=js"
export * from "./productManage.vue?vue&type=script&lang=js"
import style0 from "./productManage.vue?vue&type=style&index=0&id=7f4b8698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b8698",
  null
  
)

export default component.exports